import { render, staticRenderFns } from "./Interview.vue?vue&type=template&id=565bcf4e&scoped=true&"
import script from "./Interview.vue?vue&type=script&lang=ts&"
export * from "./Interview.vue?vue&type=script&lang=ts&"
import style0 from "./Interview.vue?vue&type=style&index=0&id=565bcf4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565bcf4e",
  null
  
)

export default component.exports